// extracted by css-extract-rspack-plugin
export default {"p":"p-m_EYn"};